export default __webpack_public_path__ + "static/1-ed131f1e4dbfe4dfde984bad4efb3b51.jpg";